import React, { useEffect } from "react";
import SideMenu from "./sideMenu";
import {
  SIDE_MENU_COLLAPSED_WIDTH,
  SIDE_MENU_EXPANDED_WIDTH,
} from "./sideMenu/sideMenu.constants";
import { Outlet } from "react-router-dom";
import { Navbar } from "./navbar";
import { Colors } from "../Constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../Redux/Slices/user.slice";
import { AppDispatch, RootState } from "../Redux/store";
import deco from "./../images/header-deco.svg";
import { SwipeableDrawer } from "@mui/material";
import { setShowSideMenuBar } from "../Redux/Slices/sideMenu.slice";
import { useMobile } from "../hooks/deviceHooks/useDevice.hooks";
import { useSocket } from "../hooks/socketHooks/socket.hooks";

const AppWrapper = () => {
  const dispatch: AppDispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const isMobile = useMobile();

  const sideMenuBar = useSelector((state: RootState) => ({
    hideSideMenuBar: state.sideMenu.hideSideMenuBar,
    isCollapsed: state.sideMenu.isCollapsed,
  }));
  const isSideMenuCollapsed = !isMobile && sideMenuBar.isCollapsed;
  const sideMenuWidth = isSideMenuCollapsed
    ? SIDE_MENU_COLLAPSED_WIDTH
    : SIDE_MENU_EXPANDED_WIDTH;

  useSocket();

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchUser());
    }
  }, [accessToken, dispatch]);

  if (!accessToken) {
    window.location.replace("/login");
    return <></>;
  }

  return (
    <div
      className="flex lg:flex-row w-full"
      style={{
        height: "100vh",
        overflowX: "hidden",
      }}
    >
      {isMobile ? (
        <SwipeableDrawer
          open={sideMenuBar.hideSideMenuBar}
          anchor="left"
          onClose={() => {
            dispatch(setShowSideMenuBar(false));
          }}
          onOpen={() => {
            dispatch(setShowSideMenuBar(true));
          }}
        >
          <div
            // className="w-1/5"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 1000,
            }}
          >
            <SideMenu />
          </div>
        </SwipeableDrawer>
      ) : (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: 1000,
            width: sideMenuWidth,
            transition: "width 0.25s ease",
          }}
        >
          <SideMenu />
        </div>
      )}

      <div
        id="app-root"
        className="flex flex-col h-full w-full"
        style={{
          marginLeft: !isMobile ? sideMenuWidth : undefined,
          marginTop: "72px", //THIS IS EQUIVALENT OF THE NAVBAR
          backgroundColor: Colors.VeryLightGrey,
          zIndex: 999,
          position: "relative",
          // Flex items default to min-width: auto, which lets any wide
          // descendant (e.g. a scrollable table) stretch this whole shell
          // wider than the viewport. Pinning it down keeps only elements
          // that explicitly opt into horizontal scrolling able to do so.
          minWidth: 0,
          overflowX: "hidden",
          transition: "margin-left 0.25s ease",
        }}
      >
        <Navbar />
        <div
          className="p-6 h-fit"
          style={{ height: "100%", width: "100%", minWidth: 0 }}
        >
          <div
            aria-hidden
            style={{
              position: "fixed",
              top: 72,
              right: 0,
              zIndex: -999,
              width: isMobile ? "300px" : "660px",
              height: isMobile ? "194px" : "426px",
              pointerEvents: "none",
              overflow: "hidden",
            }}
          >
            <img
              src={deco}
              alt=""
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top right",
              }}
            />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export default AppWrapper;
